import { render, staticRenderFns } from "./CaseExpert.vue?vue&type=template&id=44a2db10&"
import script from "./CaseExpert.vue?vue&type=script&lang=js&"
export * from "./CaseExpert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports